var map = {
	"./badge.png": "./src/assets/images/badge.png",
	"./badge.webp": "./src/assets/images/badge.webp",
	"./bitterbal-vlag-korter@3x.png": "./src/assets/images/bitterbal-vlag-korter@3x.png",
	"./bitterbal-vlag-korter@3x.webp": "./src/assets/images/bitterbal-vlag-korter@3x.webp",
	"./bitterbal_loss.png": "./src/assets/images/bitterbal_loss.png",
	"./bitterbal_loss.webp": "./src/assets/images/bitterbal_loss.webp",
	"./conversation-qr.png": "./src/assets/images/conversation-qr.png",
	"./distinctive-assets-1x.png": "./src/assets/images/distinctive-assets-1x.png",
	"./distinctive-assets-1x.webp": "./src/assets/images/distinctive-assets-1x.webp",
	"./door.svg": "./src/assets/images/door.svg",
	"./eb-logo-01-1x.svg": "./src/assets/images/eb-logo-01-1x.svg",
	"./gps.svg": "./src/assets/images/gps.svg",
	"./ig-logo-02-1x.svg": "./src/assets/images/ig-logo-02-1x.svg",
	"./ig-logo-03-1x.svg": "./src/assets/images/ig-logo-03-1x.svg",
	"./parel.png": "./src/assets/images/parel.png",
	"./parel.webp": "./src/assets/images/parel.webp",
	"./pointer.png": "./src/assets/images/pointer.png",
	"./pointer.webp": "./src/assets/images/pointer.webp",
	"./u1F60E.png": "./src/assets/images/u1F60E.png",
	"./u1F60E.webp": "./src/assets/images/u1F60E.webp",
	"./u1F610.png": "./src/assets/images/u1F610.png",
	"./u1F610.webp": "./src/assets/images/u1F610.webp",
	"./u1F623.png": "./src/assets/images/u1F623.png",
	"./u1F623.webp": "./src/assets/images/u1F623.webp",
	"./u1F913.png": "./src/assets/images/u1F913.png",
	"./u1F913.webp": "./src/assets/images/u1F913.webp",
	"./u1F928.png": "./src/assets/images/u1F928.png",
	"./u1F928.webp": "./src/assets/images/u1F928.webp",
	"./u1f440.png": "./src/assets/images/u1f440.png",
	"./u1f440.webp": "./src/assets/images/u1f440.webp",
	"./u2221.png": "./src/assets/images/u2221.png",
	"./u2221.webp": "./src/assets/images/u2221.webp",
	"./u2222.png": "./src/assets/images/u2222.png",
	"./u2222.webp": "./src/assets/images/u2222.webp",
	"./u2223.png": "./src/assets/images/u2223.png",
	"./u2223.webp": "./src/assets/images/u2223.webp",
	"./u23f3.png": "./src/assets/images/u23f3.png",
	"./u23f3.webp": "./src/assets/images/u23f3.webp",
	"./u2705.png": "./src/assets/images/u2705.png",
	"./u2705.webp": "./src/assets/images/u2705.webp",
	"./vvd-logo-02a-1x.png": "./src/assets/images/vvd-logo-02a-1x.png",
	"./vvd-logo-02a-1x.webp": "./src/assets/images/vvd-logo-02a-1x.webp",
	"./vvd-logo-02b-1x.png": "./src/assets/images/vvd-logo-02b-1x.png",
	"./vvd-logo-02b-1x.webp": "./src/assets/images/vvd-logo-02b-1x.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*$";